import { InstrumentUserInfo, InstrumentLoginConfig } from "../../model/instrument-login-model"
import { InstrumentSummary } from "../../model/instrument-configuration-model"
import { InstrumentConnection } from "../../model/instrument-connection-model"

export const InstrumentLoginActionTypes = {
    // Users
    GET_INSTRUMENT_USERS_ATTEMPT: "@@instrument-login/GET_INSTRUMENT_USERS_ATTEMPT",
    GET_INSTRUMENT_USERS_SUCCESS: "@@instrument-login/GET_INSTRUMENT_USERS_SUCCESS",
    GET_INSTRUMENT_USERS_FAILURE: "@@instrument-login/GET_INSTRUMENT_USERS_FAILURE",

    // Current user info (for login page)
    GET_CURRENT_USER_INFO_ATTEMPT: "@@instrument-login/GET_CURRENT_USER_INFO_ATTEMPT",
    GET_CURRENT_USER_INFO_SUCCESS: "@@instrument-login/GET_CURRENT_USER_INFO_SUCCESS",
    GET_CURRENT_USER_INFO_FAILURE: "@@instrument-login/GET_CURRENT_USER_INFO_FAILURE",

    // Create/update credentials
    POST_CREDENTIALS_ATTEMPT: "@@instrument-login/POST_CREDENTIALS_ATTEMPT",
    POST_CREDENTIALS_SUCCESS: "@@instrument-login/POST_CREDENTIALS_SUCCESS",
    POST_CREDENTIALS_FAILURE: "@@instrument-login/POST_CREDENTIALS_FAILURE",
    POST_CREDENTIALS_CLEAR_ERROR: "@@instrument-login/POST_CREDENTIALS_CLEAR_ERROR",

    // Unlock user
    UNLOCK_USER_ATTEMPT: "@@instrument-login/UNLOCK_USER_ATTEMPT",
    UNLOCK_USER_SUCCESS: "@@instrument-login/UNLOCK_USER_SUCCESS",
    UNLOCK_USER_FAILURE: "@@instrument-login/UNLOCK_USER_FAILURE",

    // Force expire password
    FORCE_EXPIRE_PASSWORD_ATTEMPT: "@@instrument-login/FORCE_EXPIRE_PASSWORD_ATTEMPT",
    FORCE_EXPIRE_PASSWORD_SUCCESS: "@@instrument-login/FORCE_EXPIRE_PASSWORD_SUCCESS",
    FORCE_EXPIRE_PASSWORD_FAILURE: "@@instrument-login/FORCE_EXPIRE_PASSWORD_FAILURE",

    // Delete user
    DELETE_USER_ATTEMPT: "@@instrument-login/DELETE_USER_ATTEMPT",
    DELETE_USER_SUCCESS: "@@instrument-login/DELETE_USER_SUCCESS",
    DELETE_USER_FAILURE: "@@instrument-login/DELETE_USER_FAILURE",

    // Config
    GET_CONFIG_ATTEMPT: "@@instrument-login/GET_CONFIG_ATTEMPT",
    GET_CONFIG_SUCCESS: "@@instrument-login/GET_CONFIG_SUCCESS",
    GET_CONFIG_FAILURE: "@@instrument-login/GET_CONFIG_FAILURE",
    SAVE_CONFIG_ATTEMPT: "@@instrument-login/SAVE_CONFIG_ATTEMPT",
    SAVE_CONFIG_SUCCESS: "@@instrument-login/SAVE_CONFIG_SUCCESS",
    SAVE_CONFIG_FAILURE: "@@instrument-login/SAVE_CONFIG_FAILURE",

    // Instruments
    GET_INSTRUMENTS_ATTEMPT: "@@instrument-login/GET_INSTRUMENTS_ATTEMPT",
    GET_INSTRUMENTS_SUCCESS: "@@instrument-login/GET_INSTRUMENTS_SUCCESS",
    GET_INSTRUMENTS_FAILURE: "@@instrument-login/GET_INSTRUMENTS_FAILURE",
}

export interface InstrumentLoginApiState {
    // Users
    readonly loadingUsers: boolean
    readonly users: InstrumentUserInfo[]
    readonly loadingUsersError: Error | null

    // Current user info (for login page)
    readonly loadingCurrentUserInfo: boolean
    readonly currentUserInfo: InstrumentUserInfo | null
    readonly loadingCurrentUserInfoError: Error | null

    // Credentials
    readonly postingCredentials: boolean
    readonly postingCredentialsError: Error | null

    // Unlock
    readonly unlockingUser: boolean
    readonly unlockingUserError: Error | null

    // Force expire
    readonly forcingExpire: boolean
    readonly forcingExpireError: Error | null

    // Delete
    readonly deletingUser: boolean
    readonly deletingUserError: Error | null

    // Config
    readonly loadingConfig: boolean
    readonly config: InstrumentLoginConfig
    readonly loadingConfigError: Error | null
    readonly savingConfig: boolean
    readonly savingConfigError: Error | null

    // Instruments
    readonly loadingInstruments: boolean
    readonly instruments: InstrumentSummary[]
    readonly instrumentConnections: InstrumentConnection[]
    readonly loadingInstrumentsError: Error | null
}
